/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as Yup from "yup";
import checkout from "views/platforms/new-platform/schemas/form";

const {
  formField: {
    platformName,
    platformExchange,
    vlcourtEmail,
    vlcourtPassword,
    queueIdentifier,
    routingKey,
    rmqsSelected,
    outrights,
  },
} = checkout;

const validations = [
  Yup.object().shape({
    [platformName.name]: Yup.string().required(platformName.errorMsg),
    [platformExchange.name]: Yup.string().required(platformExchange.errorMsg),
    [vlcourtEmail.name]: Yup.string().required(vlcourtEmail.errorMsg),
    [vlcourtPassword.name]: Yup.string().required(vlcourtPassword.errorMsg),
    [queueIdentifier.name]: Yup.string().required(queueIdentifier.errorMsg),
    [routingKey.name]: Yup.string().nullable(routingKey.errorMsg),
    [rmqsSelected.name]: Yup.array().required(rmqsSelected.errorMsg),
    [outrights.name]: Yup.number().required(outrights.errorMsg),
  }),
];

export default validations;
